import { render, staticRenderFns } from "./CardCadastroPlanosAssinatura.vue?vue&type=template&id=25d009ac"
import script from "./CardCadastroPlanosAssinatura.vue?vue&type=script&lang=js"
export * from "./CardCadastroPlanosAssinatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports